<template>
  <div class="container">
    <div class="tile">
      <div class="tile-content">

        <form class="form-horizontal" v-on:submit="save">
          <div class="form-group">
            <div class="container">
            <div class="columns">
              <div class="col-3 col-md-12">
                <label class="form-label">{{question.text}}</label>
              </div>
              <div class="col-4 col-md-12">
                <div class="input-group">
                  <select class="form-select" v-model="answer.atxt" @blur="save" style="width:100%;">
                    <option value="">Choose a country</option>
                    <option v-for="(val, key) in countries" :value="val">{{key}}</option>
                  </select>
                </div>
                 </div>
              </div>
            </div>
          </div>
        </form>

      </div>
      <div class="tile-action">
      </div>
    </div>
  </div>
</template>

<script>
import baseQ from '@/components/questions/base'
export default {
  name: 'countryQ',
  extends: baseQ,
  data () {
    return {
      countries: {
        'Afghanistan': 'AFGH',
        'Albania': 'ALBA',
        'Algeria': 'ALGE',
        'American Samoa': 'ASAM',
        'Andorra': 'ANDO',
        'Angola': 'ANGA',
        'Anguilla': 'ANGU',
        'Antigua and Barbuda': 'ANBA',
        'Argentina': 'ARGE',
        'Armenia': 'ARME',
        'Aruba': 'ARUB',
        'Austria': 'AUST',
        'Australia': 'AUSTRALIA',
        'Azerbaijan': 'AZER',
        'Bahamas': 'BHMS',
        'Bahrain': 'BAHR',
        'Bangladesh': 'BDES',
        'Barbados': 'BARS',
        'Belarus': 'BYEL',
        'Belgium': 'BELM',
        'Belize': 'BELZ',
        'Benin': 'BENI',
        'Bermuda': 'BERM',
        'Bhutan': 'BHUT',
        'Bolivia': 'BOLI',
        'Bonaire, Saint Eustatius and Saba': 'BSES',
        'Bosnia & Herzegovina': 'BOHE',
        'Botswana': 'BOTS',
        'Bouvet Island': 'BVTI',
        'Brazil': 'BRAZ',
        'Brit Indian Ocn Terr': 'BIOT',
        'British Overseas Territories Citizen': 'BOTC',
        'Brunei Darussalam': 'BRUI',
        'Bulgaria': 'BULG',
        'Burkina Faso': 'UVOL',
        'Burundi': 'BURU',
        'Cabo Verde': 'CABV',
        'Cambodia': 'CAMB',
        'Cameroon': 'CREP',
        'Canada': 'CANA',
        'Cape Verde': 'CVER',
        'Cayman Islands': 'CAIS',
        'Central African Rep': 'CARE',
        'Chad': 'CHAD',
        'Chile': 'CHIL',
        'China': 'PRCH',
        'Christmas Island': 'CSIS',
        'Cocos (Keeling) Isl': 'COCO',
        'Colombia': 'COLA',
        'Comoros': 'COMO',
        'Congo': 'CONG',
        'Cook Islands': 'COOI',
        'Costa Rica': 'CRIC',
        'Cote D\'ivoire': 'ICOA',
        'Croatia': 'CROA',
        'Cuba': 'CUBA',
        'Curacao': 'CURA',
        'Cyprus': 'CYPR',
        'Czech Republic': 'CZER',
        'Denmark': 'DENM',
        'Djibouti': 'JIBU',
        'Dominica': 'DOMI',
        'Dominican Republic': 'DREP',
        'Ecuador': 'ECUA',
        'Egypt': 'EGYP',
        'El Salvador': 'ESAL',
        'England': 'ENGL',
        'Equatorial Guinea': 'EQGN',
        'Eritrea': 'ERIT',
        'Estonia': 'ESTO',
        'Ethiopia': 'ETHI',
        'Falkland Islands': 'FALI',
        'Faroe Islands': 'FAIS',
        'Fiji': 'FIJI',
        'Finland': 'FINL',
        'France': 'FRAE',
        'French Guiana': 'GUYE',
        'French Polynesia': 'FPOL',
        'Fyr Macedonia': 'MKDA',
        'Gabon': 'GABO',
        'Gambia': 'GAMB',
        'Gaza Strip': 'GAZA',
        'Georgia': 'GEOG',
        'Georgia/sandwich Isl': 'SGSI',
        'Germany': 'GERM',
        'Ghana': 'GHAN',
        'Gibraltar': 'GIBR',
        'Greece': 'GREE',
        'Greenland': 'GRED',
        'Grenada': 'GREN',
        'Guadeloupe': 'GUAE',
        'Guam': 'GUAM',
        'Guatemala': 'GUAT',
        'Guernsey': 'GUER',
        'Guinea': 'GUIN',
        'Guinea-bissau': 'GUBS',
        'Guyana': 'GUYN',
        'Haiti': 'HAIT',
        'Heard & Mcdonald Isl': 'HMDI',
        'Honduras': 'HOND',
        'Hong Kong Sar': 'HKON',
        'Hungary': 'HUNG',
        'Iceland': 'ICEL',
        'India': 'INDI',
        'Indonesia': 'INDO',
        'Iran': 'IRAN',
        'Iraq': 'IRAQ',
        'Ireland, Republic of': 'IREP',
        'Isle of Man': 'IMAN',
        'Israel': 'ISRA',
        'Italy': 'ITAL',
        'Jamaica': 'JAMA',
        'Japan': 'JAPA',
        'Jersey': 'JERS',
        'Jordan': 'JORD',
        'Kazakhstan': 'KAZA',
        'Kenya': 'KENY',
        'Kiribati': 'GIIS',
        'Korea, North': 'NKOR',
        'Korea, South': 'SKOR',
        'Kosovo': 'KOSO',
        'Kuwait': 'KUWA',
        'Kyrgyzstan': 'KIRG',
        'Lao Peoples Dem Rep': 'LAOS',
        'Latvia': 'LATV',
        'Lebanon': 'LEBA',
        'Lesotho': 'LESO',
        'Liberia': 'LIBE',
        'Libya': 'LIBA',
        'Liechtenstein': 'LIEC',
        'Lithuania': 'LITH',
        'Luxembourg': 'LUXE',
        'Macau Spcl Admin Rgn': 'MACS',
        'Madagascar': 'MADA',
        'Malawi': 'MALW',
        'Malaysia': 'MALS',
        'Maldives': 'MIS',
        'Mali': 'M',
        'Malta': 'MALT',
        'Marshall Islands': 'MAIS',
        'Martinique': 'MART',
        'Mauritania': 'MAUA',
        'Mauritius': 'MAUS',
        'Mayotte': 'MAYO',
        'Mexico': 'MEXI',
        'Micronesia': 'MICS',
        'Moldova': 'MOLD',
        'Monaco': 'MONA',
        'Mongolia': 'MONG',
        'Montenegro': 'MNTE',
        'Montserrat': 'MONT',
        'Morocco': 'MORO',
        'Mozambique': 'MOZA',
        'Myanmar': 'MYAN',
        'Namibia': 'NAMI',
        'Nauru': 'NAUR',
        'Nepal': 'NEPA',
        'Netherlands': 'NETH',
        'New Caledonia': 'NCAL',
        'New Guinea': 'NEWG',
        'New Hebrides': 'NHEB',
        'New Zealand': 'NZEA',
        'Nicaragua': 'NICA',
        'Niger': 'NIGR',
        'Nigeria': 'NGRA',
        'Niue': 'NIUE',
        'Norfolk Island': 'NOIS',
        'Northern Ireland': 'NOIR',
        'Northern Mariana Isl': 'NMAI',
        'Norway': 'NORW',
        'Oman': 'OMAN',
        'Pakistan': 'PKSN',
        'Palau': 'PALA',
        'Palestinian Authorty': 'PALE',
        'Panama': 'PANA',
        'Papua New Guinea': 'NGUI',
        'Paraguay': 'PARA',
        'Peru': 'PERU',
        'Philippines': 'PHIL',
        'Pitcairn': 'PIIS',
        'Poland': 'POLA',
        'Portugal': 'PORL',
        'Puerto Rico': 'PRIC',
        'Qatar': 'QATA',
        'Reunion': 'REIS',
        'Romania': 'ROUM',
        'Russian Federation': 'RFED',
        'Rwanda': 'RWAN',
        'Saint Barthelemy': 'STBA',
        'Saint Helena, Ascension and Tristan Da Cunha': 'SHTC',
        'Saint Lucia': 'STLU',
        'Saint Martin': 'STMA',
        'Samoa': 'SAMO',
        'San Marino': 'SMAR',
        'Sao Tome & Principe': 'STPR',
        'Saudi Arabia': 'SAAR',
        'Scotland': 'SCOT',
        'Senegal': 'SENE',
        'Serbia': 'SERB',
        'Seychelles': 'SEYC',
        'Sierra Leone': 'SLEO',
        'Singapore': 'SING',
        'Sint Maarten (Dutch Part)': 'SXMN',
        'Slovak Republic': 'SVKA',
        'Slovenia': 'SLOV',
        'Solomon Islands': 'SOLI',
        'Somalia': 'SOMA',
        'South Africa': 'SAFR',
        'South Sudan': 'SSDN',
        'Spain': 'SPAI',
        'Sri Lanka': 'SRIL',
        'St Helena': 'SHEL',
        'St Kitts and Nevis': 'SCKN',
        'St Pierre & Miquelon': 'STPM',
        'St Vincent/grenadine': 'STVG',
        'Sudan': 'SUDA',
        'Suriname': 'SURI',
        'Svalbard & Jan Mayen': 'SAJM',
        'Swaziland': 'SWAZ',
        'Sweden': 'SWED',
        'Switzerland': 'SWIT',
        'Syria': 'SYRI',
        'Taiwan': 'TAIW',
        'Tajikistan': 'TADZ',
        'Tanzania': 'TANZ',
        'Thailand': 'THAI',
        'Timor, East': 'ETIM',
        'Timor-leste': 'TILE',
        'Togo': 'TOGO',
        'Tokelau': 'TOKE',
        'Tonga': 'TONG',
        'Trinidad and Tobago': 'TRIN',
        'Tunisia': 'TUNI',
        'Turkey': 'TURY',
        'Turkmenistan': 'TURM',
        'Turks and Caicos Isl': 'TCIS',
        'Tuvalu': 'TUVU',
        'U.S. Minor Islands': 'USOI',
        'Uganda': 'UGAN',
        'Ukraine': 'UKRA',
        'United Arab Emirates': 'UAEM',
        'United Kingdom': 'UK',
        'United States': 'USA',
        'Uruguay': 'URUG',
        'Uzbekistan': 'UZBE',
        'Vanuatu': 'VANU',
        'Vatican City State': 'VCIT',
        'Venezuela': 'VENE',
        'Vietnam': 'VIET',
        'Virgin Islands (U.S)': 'VIIS',
        'Virgin Islnds (Brit)': 'VIUK',
        'Wales': 'WALE',
        'Wallis & Futuna Isl': 'WAFU',
        'West Bank': 'WBAN',
        'Yemen': 'YEME',
        'Yugoslavia': 'FRY',
        'Zaire': 'ZAIR',
        'Zambia': 'ZAMB',
        'Zimbabwe': 'ZIMB'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// country.vue?4f8f70a4